module.exports = __webpack_public_path__ + "img/structure hamac.52f1b56c.jpg";